import { setCookie } from "cookies-next";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { LOCALE_COOKIE_NAME } from "@/constants";
import { useProfile } from "@/hooks/profile";
import useLocaleHelper from "@/hooks/useLanguageHelper";
import { authStatusFromProfileQuery } from "@/hooks/useProfile";
import { I18nextLocale } from "@/types/types";

export const useLanguageSwitch = () => {
  const router = useRouter();
  const {
    i18n: { changeLanguage: i18nChangeLocale },
  } = useTranslation();
  const profile = useProfile();
  const { pathname, asPath, query, locale } = router;
  const { isLoggedIn } = authStatusFromProfileQuery(profile);
  const { getLocaleParts } = useLocaleHelper();

  const handleLanguageChange = (locale: I18nextLocale) => {
    const { lang } = getLocaleParts(locale);
    i18nChangeLocale(locale);
    setCookie(LOCALE_COOKIE_NAME, lang);
    router.push({ pathname, query }, asPath, {
      locale: locale,
      scroll: false,
      shallow: true,
    });

    if (!isLoggedIn) return;

    try {
      fetch(`/api/user/locale/${lang}`, {
        method: "PUT",
      });
    } catch (error) {
      console.error(error);
    }
  };

  return {
    handleLanguageChange,
    locale,
  };
};
